import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PATHS } from "../routes/paths";
import {
  atualizarCidade,
  excluirCidade,
  listCidadesAdmin,
} from "../services/cidades";
import { ConfirmDialog, SuccessDialog } from "../components/Admin/Dialogs";
import "./AdminCidades.css";

export default function AdminCidades() {
  const [cidades, setCidades] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(null);
  const [cidadeParaExcluir, setCidadeParaExcluir] = useState(null);
  const [excluindo, setExcluindo] = useState(false);
  const [alterandoStatusId, setAlterandoStatusId] = useState(null);
  const [acaoErro, setAcaoErro] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const carregar = useCallback(() => {
    setCarregando(true);
    listCidadesAdmin()
      .then((data) => {
        setCidades(Array.isArray(data) ? data : []);
        setErro(null);
      })
      .catch(() => setErro("Não foi possível carregar as cidades."))
      .finally(() => setCarregando(false));
  }, []);

  useEffect(() => {
    carregar();
  }, [carregar]);

  const confirmarExclusao = async () => {
    if (!cidadeParaExcluir) return;

    setExcluindo(true);
    setAcaoErro("");

    try {
      await excluirCidade(cidadeParaExcluir._id || cidadeParaExcluir.id);
      setCidadeParaExcluir(null);
      setSuccessMessage("Cidade removida com sucesso!");
      carregar();
    } catch (error) {
      setAcaoErro(
        error?.response?.data?.message ||
          "Não foi possível excluir esta cidade.",
      );
    } finally {
      setExcluindo(false);
    }
  };

  const alternarStatus = async (cidade) => {
    const id = cidade._id || cidade.id;
    if (!id || cidade._isFallback) return;

    setAlterandoStatusId(id);
    setAcaoErro("");

    try {
      await atualizarCidade(id, { active: cidade.active === false });
      carregar();
    } catch (error) {
      setAcaoErro(
        error?.response?.data?.message ||
          "Não foi possível alterar o status da cidade.",
      );
    } finally {
      setAlterandoStatusId(null);
    }
  };

  return (
    <div className="page-shell admin-cidades">
      <div className="page-shell__content">
        <div className="admin-cidades__cabecalho">
          <div>
            <h1 className="page-shell__title">Editar cidades</h1>
            <p className="page-shell__description">
              Selecione um núcleo regional para atualizar seu conteúdo.
            </p>
          </div>
          <Link to={PATHS.adminCidadeNova} className="admin-cidades__nova">
            + Nova cidade
          </Link>
        </div>

        {carregando && <p>Carregando cidades...</p>}
        {!carregando && !erro && cidades.some((cidade) => cidade._isFallback) && (
          <p className="admin-cidades__aviso">
            Não foi possível conectar ao servidor. As cidades abaixo são dados
            de exemplo, apenas para visualização — conecte o back ao banco
            para editar de verdade.
          </p>
        )}
        {!carregando && erro && (
          <p className="admin-cidades__erro">{erro}</p>
        )}
        {!carregando && !erro && acaoErro && (
          <p className="admin-cidades__erro">{acaoErro}</p>
        )}
        {!carregando && !erro && cidades.length === 0 && (
          <p>Nenhuma cidade cadastrada ainda.</p>
        )}
        {!carregando && !erro && cidades.length > 0 && (
            <div className="admin-cidades__grade">
              {cidades.map((cidade) => (
                <div
                  key={cidade._id || cidade.slug}
                  className="admin-cidades__card-item"
                >
                  <Link
                    to={PATHS.adminCidade.replace(":slug", cidade.slug)}
                    state={{ cidade }}
                    className="admin-cidades__card"
                  >
                    <div>
                      <h2>{cidade.city || cidade.name}</h2>
                      <p>Núcleo 7 Geração - ProSer</p>
                    </div>
                    <span
                      className={`admin-cidades__status ${cidade.active === false ? "admin-cidades__status--inativa" : "admin-cidades__status--ativa"}`}
                    >
                      {cidade.active === false ? "Oculta" : "Ativa"}
                    </span>
                    <strong>Ver conteúdo →</strong>
                  </Link>

                  {!cidade._isFallback && (
                    <div className="admin-cidades__acoes">
                      <button
                        type="button"
                        disabled={alterandoStatusId === (cidade._id || cidade.id)}
                        onClick={() => alternarStatus(cidade)}
                      >
                        {alterandoStatusId === (cidade._id || cidade.id)
                          ? "Salvando..."
                          : cidade.active === false
                            ? "Ativar"
                            : "Ocultar"}
                      </button>
                      <button
                        type="button"
                        className="admin-cidades__excluir"
                        onClick={() => setCidadeParaExcluir(cidade)}
                      >
                        Excluir
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
        )}
      </div>

      <ConfirmDialog
        open={Boolean(cidadeParaExcluir)}
        title="Confirmar a exclusão?"
        description={
          cidadeParaExcluir
            ? `A cidade "${cidadeParaExcluir.city || cidadeParaExcluir.name}" será removida permanentemente, incluindo todo o conteúdo cadastrado.`
            : ""
        }
        busy={excluindo}
        onCancel={() => setCidadeParaExcluir(null)}
        onConfirm={confirmarExclusao}
      />
      <SuccessDialog
        open={Boolean(successMessage)}
        message={successMessage}
        onClose={() => setSuccessMessage("")}
      />
    </div>
  );
}
